import { Component, ElementRef, inject, input, OnDestroy, OnInit, output, Renderer2, signal, viewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ResizeService } from 'src/app/shared/services/resize/resize.service';

@Component({
    selector: 'app-sopo-tooltip',
    templateUrl: './sopo-tooltip.component.html',
    styleUrls: ['./sopo-tooltip.component.scss'],
    host: {
        '(click)': 'dismiss()',
        '[class.clickable]': 'true',
    },
    standalone: true,
})
export class SopoTooltipComponent implements OnInit, OnDestroy {
    private _renderer2 = inject(Renderer2);
    private _resizeService = inject(ResizeService);
    private _tooltipMessageRef = viewChild('tooltipMessage', { read: ElementRef });
    private _resizeSubscription: Subscription;
    message = input.required<string>();
    element = input.required<HTMLElement>();
    close = output();
    top = signal(0);
    left = signal(0);

    ngOnInit() {
        this.calculatePosition();
        this._resizeSubscription = this._resizeService.getResizeObservable().pipe(
            delay(300)
        ).subscribe(() => {
            this.calculatePosition();
        });
    }

    private calculatePosition() {
        if (this.element) {
            const rect = this.element().getBoundingClientRect();
            this.top.set(rect.y + rect.height / 2);
            this.left.set(rect.x + rect.width / 2);
        }
    }

    dismiss() {
        this._renderer2.addClass(this._tooltipMessageRef().nativeElement, 'fade-out');
    }

    onAnimationEnd(event: AnimationEvent) {
        if (event.animationName.includes('fade-out')) {
            this.close.emit();
        }
    }

    onMessageClick(event: Event) {
        event.stopPropagation();
    }

    ngOnDestroy(): void {
        if (this._resizeSubscription) this._resizeSubscription.unsubscribe();
    }
}
